<button mat-flat-button (click)="onBack()">
  <i class="icon">arrow_back</i>
  <span>Back</span>
</button>
